import Day1 from '../../components/dayComponents/Day01.js';
import Day2 from '../../components/dayComponents/Day02.js';
import Day3 from '../../components/dayComponents/Day03.js';
import Day4 from '../../components/dayComponents/Day04.js';
import Day5 from '../../components/dayComponents/Day05.js';
import Day6 from '../../components/dayComponents/Day06.js';
import Day7 from '../../components/dayComponents/Day07.js';
import Day8 from '../../components/dayComponents/Day08.js';
import Day9 from '../../components/dayComponents/Day09.js';
import Day10 from '../../components/dayComponents/Day10.js';
import Day11 from '../../components/dayComponents/Day11.js';
import Day12 from '../../components/dayComponents/Day12.js';

export default [
    { component: Day1, title: "Day 1" },
    { component: Day2, title: "Day 2" },
    { component: Day3, title: "Day 3" },
    { component: Day4, title: "Day 4" },
    { component: Day5, title: "Day 5" },
    { component: Day6, title: "Day 6" },
    { component: Day7, title: "Day 7" },
    { component: Day8, title: "Day 8" },
    { component: Day9, title: "Day 9" },
    { component: Day10, title: "Day 10" },
    { component: Day11, title: "Day 11" },
    { component: Day12, title: "Day 12" }
];
